import _ from 'lodash'
import { isNil } from 'core/service/lib/type-check'
import SummaryRow from './summary-row'
import SummaryFooter from './summary-footer'
import MESSAGES from 'core/data-model/constants/messages'
import BIMESSAGES from 'core/data-model/constants/bi-messages'
import values from 'core/data-model/constants/values'
import {
  getRiderYearsOfCoverage,
  getRiderYearsOfPayment,
  hasAsteriskFromRiders,
} from 'core/service/rider/benefits/benefit-data'
import { getRiderAsterisks } from 'core/service/benefit-illustration/benefit-summary'
import { getSumAssuredDisplayValue } from 'core/service/pdf-generation/products/common/logic'
import { getRiderSumAssuredDisplayValue } from 'core/service/benefit-illustration/profile-summary'
import { getToggles } from 'quick-quote/feature-toggles'
import { isS7Product } from 'core/service/basic-plan/benefit'
import { formatNumber } from 'core/service/lib/number-format'

export const isNoShowAsterisk = (displayProduct) =>
  isS7Product(_.get(displayProduct, 'basicPlanCode')) ||
  values.PRODUCT_GIO.includes(_.get(displayProduct, 'basicPlanCode'))

const SummaryTable = ({
  displayProduct,
  riders,
  calculatedCoveragePeriod,
  calculatedPaymentPeriod,
  basicPremium,
  basicSumAssured,
  totalPremium,
  hasNonLevelRider,
  hasShowDisclaimerRiderAsterisk,
  selectedModelFactorID,
  selectedModelFactorLabel,
  summaryTableHeader,
  isNewAsteriskOfSummaryMainContract,
  isCheckHaveBasicCampaignDiscountActive,
  campaignDiscountMessage,
}) => {
  if (isNil(displayProduct)) {
    return
  }

  return (
    <div className="summary-table d-none d-md-block">
      <div className="details-table">
        <h3>
          {displayProduct.riders.length
            ? BIMESSAGES.SUMMARY_OF_MAIN_AND_ADDITIONAL_CONTRACTS
            : BIMESSAGES.SUMMARY_OF_MAIN_CONTRACTS}
        </h3>
        <table id="summary-table">
          <thead>
            <tr>
              <td>
                {displayProduct.riders.length ? BIMESSAGES.BASIC_PLAN + '/' + BIMESSAGES.RIDER : BIMESSAGES.BASIC_PLAN}
              </td>
              <td>
                {BIMESSAGES.COVERAGE_PERIOD} ({MESSAGES.TIME_UNIT_YEAR})
              </td>
              <td>
                {BIMESSAGES.PAYMENT_PERIOD} ({MESSAGES.TIME_UNIT_YEAR})
              </td>
              <td>
                {BIMESSAGES.SUM_ASSURED} ({MESSAGES.BAHT})
                {isNoShowAsterisk(displayProduct) || isNewAsteriskOfSummaryMainContract ? '' : '****'}
              </td>
              <td>
                {BIMESSAGES.PREMIUM}
                {isNoShowAsterisk(displayProduct) || isNewAsteriskOfSummaryMainContract ? '' : '**'} ({MESSAGES.BAHT})
              </td>
            </tr>
          </thead>
          <tbody>
            {renderBasicPlanSummaryRow(
              displayProduct,
              calculatedCoveragePeriod,
              selectedModelFactorID === 'model-factor_5' ? selectedModelFactorLabel : calculatedPaymentPeriod,
              basicSumAssured,
              basicPremium,
              summaryTableHeader
            )}
            {renderRidersSummaryRows(riders, isNewAsteriskOfSummaryMainContract)}
            <SummaryFooter totalPremium={totalPremium} />
          </tbody>
        </table>
        {isCheckHaveBasicCampaignDiscountActive && campaignDiscountMessage.length === 5 && (
          <div>
            <div className="disclaimer">{campaignDiscountMessage[4]}</div>
            <br />
          </div>
        )}
        {isNoShowAsterisk(displayProduct) ? (
          ''
        ) : isNewAsteriskOfSummaryMainContract ? (
          newAsteriskOfSummaryMainContractDiv(riders, hasShowDisclaimerRiderAsterisk, hasNonLevelRider)
        ) : (
          <div className="disclaimer">
            <ul className="list-unstyled">
              {hasAsteriskFromRiders(riders) ? <li>* {_getDisclaimerRiderPremiumMessage(riders)}</li> : ''}
              <li>** {BIMESSAGES.DISCLAIMER_OCCUPATION_PREMIUM}</li>
              {getToggles().ENABLE_EXCEPT_DISCLAIMER_RIDER_BENEFIT_TABLE
                ? hasShowDisclaimerRiderAsterisk && (
                    <li>*** {BIMESSAGES.SUMMARY_TABLE_DISCLAIMER_HAS_NON_LEVEL_RIDER}</li>
                  )
                : hasNonLevelRider && <li>*** {BIMESSAGES.SUMMARY_TABLE_DISCLAIMER_HAS_NON_LEVEL_RIDER}</li>}
              <li>**** {BIMESSAGES.DISCLAIMER_SPECIAL_OCCUPATION_PREMIUM}</li>
              {getDisclaimerFiveAsterisksMessage(riders)}
              <br />
              <div className="disclaimerSummaryBox">
                <li>{BIMESSAGES.FLEXI_SUMMARY_TABLE_DISCLAIMER_3}</li>
                <li>{BIMESSAGES.FLEXI_SUMMARY_TABLE_DISCLAIMER_4}</li>
              </div>
            </ul>
          </div>
        )}
      </div>
    </div>
  )
}

export const newAsteriskOfSummaryMainContractDiv = (
  riders,
  hasShowDisclaimerRiderAsterisk,
  hasNonLevelRider,
  displayProduct
) => {
  return (
    <div className="disclaimer">
      <ul className="list-unstyled">
        {hasAsteriskFromRiders(riders) ? <li>* {_getDisclaimerRiderPremiumMessage(riders)}</li> : ''}
        {getToggles().ENABLE_EXCEPT_DISCLAIMER_RIDER_BENEFIT_TABLE
          ? hasShowDisclaimerRiderAsterisk && <li>** {BIMESSAGES.SUMMARY_TABLE_DISCLAIMER_HAS_NON_LEVEL_RIDER}</li>
          : hasNonLevelRider && <li>** {BIMESSAGES.SUMMARY_TABLE_DISCLAIMER_HAS_NON_LEVEL_RIDER}</li>}
        {getDisclaimerThreeAsterisksMessage(riders)}
        {getDisclaimerFourAsterisksMessage(riders)}
        {summaryTableDisclaimer(displayProduct)}
      </ul>
    </div>
  )
}

const summaryTableDisclaimer = (displayProduct) => {
  if (values.BUMNAN_SMART_GROUP.includes(displayProduct?.basicPlanCode)) {
    return
  }
  return (
    <>
      <br />
      <div className="disclaimerSummaryBox">
        <li>{BIMESSAGES.FLEXI_SUMMARY_TABLE_DISCLAIMER_3}</li>
        <li>{BIMESSAGES.FLEXI_SUMMARY_TABLE_DISCLAIMER_4}</li>
      </div>
    </>
  )
}

export const _getDisclaimerRiderPremiumMessage = (riders) => {
  return _.some(riders, (rider) => _.get(rider, 'code') === values.MEK)
    ? BIMESSAGES.DISCLAIMER_MEK_RIDER_PREMIUM
    : BIMESSAGES.DISCLAIMER_RIDER_PREMIUM
}

export const getDisclaimerThreeAsterisksMessage = (riders) => {
  return _.some(riders, (rider) => values.LIST_FIVE_ASTERISKS_BENEFIT_SUMMARY_TABLE.includes(_.get(rider, 'code'))) ? (
    <div>
      <li>
        *** {BIMESSAGES.SUMMARY_TABLE_DISCLAIMER_HEALTH_RIDER_TITLE}
        <ol>
          <li>{BIMESSAGES.SUMMARY_TABLE_DISCLAIMER_HEALTH_RIDER_FIRST}</li>
          <li>{BIMESSAGES.SUMMARY_TABLE_DISCLAIMER_HEALTH_RIDER_SECOND}</li>
          <li>{BIMESSAGES.SUMMARY_TABLE_DISCLAIMER_HEALTH_RIDER_THIRD}</li>
          {BIMESSAGES.SUMMARY_TABLE_DISCLAIMER_HEALTH_RIDER_THIRD_2}
        </ol>
      </li>
    </div>
  ) : (
    ''
  )
}
export const getDisclaimerFourAsterisksMessage = (riders) => {
  return _.some(riders, (rider) => values.LIST_FOUR_ASTERISKS_BENEFIT_SUMMARY_TABLE.includes(_.get(rider, 'code'))) ? (
    <div>
      <li>**** {BIMESSAGES.DISCLAIMER_CIES_RIDER_PREMIUM}</li>
    </div>
  ) : (
    ''
  )
}

export const getDisclaimerFiveAsterisksMessage = (riders) => {
  return _.some(riders, (rider) => values.LIST_FIVE_ASTERISKS_BENEFIT_SUMMARY_TABLE.includes(_.get(rider, 'code'))) ? (
    <div>
      <li>
        ***** {BIMESSAGES.SUMMARY_TABLE_DISCLAIMER_HEALTH_RIDER_TITLE}
        <ol>
          <li>{BIMESSAGES.SUMMARY_TABLE_DISCLAIMER_HEALTH_RIDER_FIRST}</li>
          <li>{BIMESSAGES.SUMMARY_TABLE_DISCLAIMER_HEALTH_RIDER_SECOND}</li>
          <li>{BIMESSAGES.SUMMARY_TABLE_DISCLAIMER_HEALTH_RIDER_THIRD}</li>
          {BIMESSAGES.SUMMARY_TABLE_DISCLAIMER_HEALTH_RIDER_THIRD_2}
        </ol>
      </li>
    </div>
  ) : (
    ''
  )
}

const renderBasicPlanSummaryRow = (
  displayProduct,
  calculatedCoveragePeriod,
  calculatedPaymentPeriod,
  basicSumAssured,
  basicPremium,
  summaryTableHeader
) => {
  const productName = _.isFunction(summaryTableHeader)
    ? // $$FlowFixMe
      summaryTableHeader({
        displayProduct,
        calculatedCoveragePeriod,
        calculatedPaymentPeriod,
        basicSumAssured,
        basicPremium,
      })
    : summaryTableHeader
  const sumAssured = getSumAssuredDisplayValue(displayProduct, basicSumAssured, false)

  return (
    <SummaryRow
      id={displayProduct.code}
      productCode={displayProduct.basicPlanCode}
      productName={
        // $$FlowFixMe
        productName
      }
      selectedPlan={{ planCode: '' }} // not applicable for basic plan
      coverageYear={calculatedCoveragePeriod}
      paymentPeriod={calculatedPaymentPeriod}
      premium={basicPremium}
      sumAssured={sumAssured}
      showSumAssuredDecimalPlaces={false}
    />
  )
}

const renderRiderProductNameSummaryRows = (rider) => {
  switch (rider.code) {
    case values.MEH:
      return `${BIMESSAGES.RIDER} ${rider.description}`
    case values.MHP:
      return `${BIMESSAGES.RIDER_HEALTH}${rider.description}`
    case values.WPC:
    case values.WPC25PL:
    case values.WPCWL60:
    case values.WPCWL99:
    case values.WPEWL85:
    case values.WPEIP85:
      return `${BIMESSAGES.RIDER}${BIMESSAGES.BENEFIT_TITLE}${rider.description}`
    case values.PBPDD:
    case values.PBSDD:
      return `${BIMESSAGES.PB_FIT_NAME}`
    case values.PBPDDCI:
    case values.PBSDDCI:
      return `${BIMESSAGES.PB_BEYOND_NAME}`
    case values.MCI:
      return `${BIMESSAGES.RIDER_HEALTH}<br/>${rider.description}`
    default:
      return `${BIMESSAGES.RIDER}${rider.description}`
  }
}

const renderRiderProductCodeSummaryRows = (rider) => {
  if (rider.code === values.MCI) {
    return rider.code
  }
  return rider.package ? rider.selectedPlan.planCode : rider.name
}

export const buildGroupedSummaryRows = (selectedPlanGroup) => {
  const planArray = _.values(selectedPlanGroup)
  const grouped = _.groupBy(planArray, 'group')

  return _.compact(
    values.CIES_GROUP_ORDER.map((groupKey) => {
      const plans = grouped[groupKey]
      if (!plans || plans.length === 0) return null

      const shouldSumPremium = plans.length > 1

      const label =
        plans.find((p) => p.descriptionDisplay)?.descriptionDisplay?.replace(/\n/g, '') || plans[0].description

      const premium = shouldSumPremium
        ? _.round(
            _.sumBy(plans, (p) => Number(p.riderPremium) || 0),
            2
          )
        : Number(plans[0].riderPremium) || 0

      const SA = Number(plans[0].riderSumAssured) || 0

      return {
        key: groupKey,
        label,
        plans,
        premium,
        SA,
      }
    })
  )
}

const renderRidersSummaryRows = (riders, isNewAsteriskOfSummaryMainContract) => {
  if (isNil(riders)) return

  return riders.map((rider) => {
    if (rider.code === values.CIES) {
      const groupedRows = buildGroupedSummaryRows(rider.selectedPlanGroup)

      return groupedRows.map((group) => (
        <SummaryRow
          key={`summary-row-${rider.code}-${group.key}`}
          id={rider.code}
          productCode={renderRiderProductCodeSummaryRows(rider)}
          productName={group.label}
          asterisks={getRiderAsterisks(rider, isNewAsteriskOfSummaryMainContract)}
          coverageYear={getRiderYearsOfCoverage(rider)}
          paymentPeriod={getRiderYearsOfPayment(rider, { hasAsterisk: true })}
          selectedPlan={{
            ...rider.selectedPlan,
            planCode: rider.package ? '' : rider.selectedPlan.planCode,
          }}
          sumAssured={formatNumber(group.SA)}
          showSumAssuredDecimalPlaces={rider.showSumAssuredDecimalPlaces}
          premium={group.premium}
        />
      ))
    } else {
      return (
        // $$FlowFixMe
        <SummaryRow
          key={`summary-row-${rider.code}`}
          id={rider.code}
          productCode={renderRiderProductCodeSummaryRows(rider)}
          productName={renderRiderProductNameSummaryRows(rider)}
          asterisks={getRiderAsterisks(rider, isNewAsteriskOfSummaryMainContract)}
          coverageYear={getRiderYearsOfCoverage(rider)}
          paymentPeriod={getRiderYearsOfPayment(rider, { hasAsterisk: true })}
          selectedPlan={{
            ...rider.selectedPlan,
            planCode: rider.package ? '' : rider.selectedPlan.planCode,
          }}
          sumAssured={getRiderSumAssuredDisplayValue(rider)}
          showSumAssuredDecimalPlaces={rider.showSumAssuredDecimalPlaces}
          premium={rider.premium}
        />
      )
    }
  })
}

export default SummaryTable
